import { useState, useEffect } from "react";
import { UserPlus, ChevronRight, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function ReferralsWidget() {
  var countState = useState(0);
  var count = countState[0];
  var setCount = countState[1];
  var recentState = useState([]);
  var recent = recentState[0];
  var setRecent = recentState[1];
  var navigate = useNavigate();

  useEffect(function() {
    api.get("/referrals/unread-count").then(function(r) { setCount(r.data.count || 0); }).catch(function() {});
    api.get("/referrals?status=nova&limit=5").then(function(r) { setRecent(r.data.referrals || []); }).catch(function() {});
  }, []);

  if (count === 0 && recent.length === 0) return null;

  return (
    <div className="bg-white rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-sm mb-6 lg:mb-8 border border-[#F26A4B]/20" data-testid="referrals-widget">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="p-2 bg-[#F26A4B]/10 rounded-xl relative">
            <UserPlus className="w-5 h-5 text-[#F26A4B]" />
            {count > 0 && <Sparkles className="w-3 h-3 text-amber-400 absolute -top-0.5 -right-0.5 animate-pulse" />}
          </div>
          <div>
            <h3 className="text-base lg:text-lg font-bold text-[#0A2F3D]">Novas Indicacoes</h3>
            {count > 0 && <p className="text-xs text-[#F26A4B] font-medium">{count} pendente(s)</p>}
          </div>
        </div>
        <button onClick={function() { navigate("/indicacoes"); }} className="flex items-center gap-1 text-xs text-[#3B82F6] font-medium hover:underline" data-testid="referrals-see-all">
          Ver todas<ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>
      <div className="space-y-2">
        {recent.map(function(ref) {
          return (
            <div key={ref.id} className="flex items-center justify-between p-3 bg-[#F26A4B]/5 rounded-xl" data-testid={"referral-widget-" + ref.id}>
              <div>
                <p className="text-sm font-medium text-[#0A2F3D]">{ref.name}</p>
                <p className="text-xs text-gray-500">Indicado por {ref.referred_by_name} - {ref.phone}</p>
              </div>
              <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-amber-100 text-amber-700">Nova</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
